import { AXIOS, CommonGlobalService, UUID } from '@umanforge/common';
import { AxiosResponse } from 'axios';
import { Dispatch } from '@reduxjs/toolkit';
import { API } from 'constants/api.constant';
import { ToastService } from './toast.service';
import { ErrorService } from './error.service';

const toastService = new ToastService( 'ChartPing Service' );
const errorService = new ErrorService( toastService );

export class ChartPingService {
  static postPing = async ( chartInfoId: UUID, token: string | null, dispatch: Dispatch ): Promise<boolean> => {
    try {
      const response: AxiosResponse = await AXIOS.post(
        `${API.CHART_OF_SECTION}/${chartInfoId}/ping`,
        {},
        await CommonGlobalService.getHeaderRequest( token )
      );
      CommonGlobalService.saveRequestToken( response, dispatch );
      return response.status === 200 || response.status === 201 || response.status === 204;
    } catch ( error ) {
      errorService.showCatchAxiosError( error );
      return false;
    }
  };

  static resetPing = async ( chartInfoId: UUID, token: string | null, dispatch: Dispatch ): Promise<boolean> => {
    try {
      const response: AxiosResponse = await AXIOS.delete(
        `${API.CHART_OF_SECTION}/${chartInfoId}/ping`,
        await CommonGlobalService.getHeaderRequest( token )
      );
      CommonGlobalService.saveRequestToken( response, dispatch );
      return response.status === 200 || response.status === 201 || response.status === 204;
    } catch ( error ) {
      errorService.showCatchAxiosError( error );
      return false;
    }
  };

}
